import type { Locale } from 'date-fns/locale'
import { enGB, fr } from 'date-fns/locale'

export function localeToDateFnsLocale(locale: string): Locale {
  switch (locale) {
    case 'en-GB':
      return enGB

    case 'fr':
      return fr

    default:
      return enGB
  }
}
